import { useNavigate } from "react-router-dom";

const UserAccountReelsNavigation = (userId) => {
  const navigate = useNavigate();

  const goToUserAccountReels = () => {
    navigate(`/useraccount-reels/${userId}`); // Ensure this route exists in your app
  };

  return { goToUserAccountReels }; // ✅ Return an object
};

export default UserAccountReelsNavigation;